import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteExercise, deleteExerciseSession } from '../../../api/diary-service';

const useDeleteExercise = (currentDay) => {
    const [isDeleting, setIsDeleting] = useState(false);
    const queryClient = useQueryClient();

    // SINGLE EXERCISE DELETE
    const singleDelete = useMutation({
        mutationFn: deleteExercise,
        onError: (error) => console.error('Failed to delete exercise:', error)
    });

    // FULL DAY (SESSION) DELETE
    const sessionDelete = useMutation({
        mutationFn: deleteExerciseSession,
        onError: (error) => console.error('Failed to delete exercise session:', error)
    });

    const deleteExerciseAndSync = async (exerciseId = null) => {
        setIsDeleting(true);

        try {
            if (exerciseId) await singleDelete.mutateAsync(exerciseId);
            else await sessionDelete.mutateAsync(currentDay);

            await queryClient.refetchQueries({ queryKey: ['diary', currentDay] });
            await queryClient.invalidateQueries({
                queryKey: ['exerciseSessionDates'],
                exact: false
            });
        } catch (error) {
            console.error('Delete and sync failed:', error);
        } finally {
            setIsDeleting(false);
        }
    };

    return {
        deleteExercise: deleteExerciseAndSync,
        isDeleting,
        isSuccess: singleDelete.isSuccess || sessionDelete.isSuccess,
        isError: singleDelete.isError || sessionDelete.isError,
        error: singleDelete.error || sessionDelete.error
    };
};

export default useDeleteExercise;
